import Wallet from '../components/Wallet'
import { walletServiceConfig } from './shared/config'

import injectWidget from './shared/injectWidget'

const WalletWidget = injectWidget({
  widget: Wallet,
  serviceConfig: walletServiceConfig,
})

export default WalletWidget
